import { type OpenApiSchemaDiscount } from '#shared/api/schema';

export const discountDefaults: OpenApiSchemaDiscount = {
    id: '',
    kind: 'REGULAR',
    created_at: '',
    updated_at: '',
    title: '',
    discount_value: {
        value: '',
        type: 'PERCENT',
    },
    discount_objects: {},
    discount_dates: {
        start_date: '',
        end_date: '',
    },
    is_active: true,
    discount_applicability: 'ALL_PRODUCTS',
    is_currently_active: true,
};

export const DISCOUNT_FILTER_TITLE = 'Акции';
